import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH,
    FETCH_FAILURE,
    FETCH_SUCCESS,
    INITIALIZE_FORM,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_CURRENT_VALUES,
    SET_THEME,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    currentValues: {
        first_name: null,
        last_name: null,
        picture: null,
    },
    fetch: {
        isFetching: false,
        data: [],
        error: null,
    },
    initialValues: {
        id: null,
        email: null,
        first_name: null,
        last_name: null,
        picture: null,
    },
    save: {
        isSaving: false,
        data: {},
        errors: null,
    },
    theme: 'light',
};

const profileSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH]: (state) => {
            state.fetch = { ...state.fetch, errors: [], isFetching: true };
        },
        [FETCH_FAILURE]: (state, action) => {
            state.fetch = {
                ...state.fetch,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_SUCCESS]: (state, action) => {
            state.fetch = {
                ...state.fetch,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [SAVE]: (state) => {
            state.save = { ...state.save, errors: [], isSaving: true };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state, action) => {
            state.save = {
                ...state.save,
                date: action.payload,
                isSaving: false,
            };
        },
        [SET_CURRENT_VALUES]: (state, action) => {
            state.currentValues = { ...state.currentValues, ...action.payload };
        },
        [SET_THEME]: (state, action) => {
            state.theme = action.payload;
        },
    },
});

export const profileActions = profileSlice.actions;

export default profileSlice.reducer;
